module.exports = __webpack_public_path__ + "img/Mando-Emoji.65c86f3f.png";